import { z } from 'zod';

/**
 * Ordner im Dokumentenmanagement (ADR 0021). Scope-Regel: kein Bezug = globaler
 * Bereich; genau eines von projectId/customerId = Entitäts-Bereich.
 */
export const createFolderSchema = z
  .object({
    name: z.string().trim().min(1).max(200),
    parentId: z.string().uuid().optional(),
    projectId: z.string().uuid().optional(),
    customerId: z.string().uuid().optional(),
  })
  .refine((value) => !(value.projectId && value.customerId), {
    message: 'Ein Ordner kann nicht gleichzeitig Projekt und Kunde zugeordnet sein.',
    path: ['customerId'],
  });
export type CreateFolderInput = z.infer<typeof createFolderSchema>;

/** Umbenennen und/oder Verschieben (neuer Elternordner). */
export const updateFolderSchema = z.object({
  name: z.string().trim().min(1).max(200).optional(),
  parentId: z.string().uuid().nullable().optional(),
});
export type UpdateFolderInput = z.infer<typeof updateFolderSchema>;

/** Filter für die Ordner-/Datei-Liste: nach Elternordner oder Entitäts-Scope. */
export const dmsScopeQuerySchema = z.object({
  parentId: z.string().uuid().optional(),
  projectId: z.string().uuid().optional(),
  customerId: z.string().uuid().optional(),
});
export type DmsScopeQuery = z.infer<typeof dmsScopeQuerySchema>;

export const folderResponseSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  parentId: z.string().uuid().nullable(),
  name: z.string(),
  path: z.string(),
  depth: z.number().int(),
  projectId: z.string().uuid().nullable(),
  customerId: z.string().uuid().nullable(),
  isSystem: z.boolean(),
  childFolderCount: z.number().int(),
  documentCount: z.number().int(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type FolderResponse = z.infer<typeof folderResponseSchema>;
